import { IPlan } from '@reolink-cloud/interface';
import { IDuration, ISeriesItem } from './types';

export const getPlansByDuration = ( seriesList: ISeriesItem[], duration: IDuration ): IPlan[] => {

    return Object.values( seriesList ).sort(( a, b ) => ( a.sortOrder ?? 0 ) - ( b.sortOrder ?? 0 )).reduce(( plans: IPlan[], seriesItem ) => {

        const matchedPlans = seriesItem.products.filter( product => {

            return product.duration.unit === duration.unit && product.duration.amount === duration.amount;

        });

        return plans.concat( matchedPlans.sort(( a, b ) => a.style['plan.sort'] - b.style['plan.sort'] ));

    }, [] );

};
